<template>
    <v-container px-4 pa-0 class="container-with-horizontal-scroll" fluid>
        <v-row>
            <v-col cols="12" sm="6" md="4" lg="3" class="pa-1 ma-0">
                <v-card class="blue-grey lighten-5">
                    <v-card-title class="ml-2 pa-1">
                        <v-list-item-title class="bold subtitle-1">
                            В работе
                        </v-list-item-title>
                    </v-card-title>
                    <div v-bind:style="[{height: (windowHeight - 160) + 'px'},{display: 'flex'},{'flex-direction': 'column'}]">
                        <div class="content">
                            <v-card-text class="pa-0 ma-0"
                                         v-for="(event, index) in events"
                                         :key="event.id"
                            >
                                <event-card
                                        :model="event"
                                        :index="index"
                                        @editModel="editEvent(index)"
                                        @removeModel="removeEvent"
                                ></event-card>
                            </v-card-text>
                        </div>
                    </div>
                    <v-card-actions class="ma-0 pa-0">
                        <EventForm
                                :index="indexEdit"
                                :dialog="dialog"
                                @addMailing="addEvent"
                                @close="dialog = false"
                        ></EventForm>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import EventCard from '../../components/bot/event/EventCard'
import EventForm from '../../components/bot/event/EventForm'
import { mapGetters } from 'vuex'

export default {
    name: 'Index',
    components: {
        EventCard,
        EventForm
    },
    data() {
        return {
            dialog: false,
            indexEdit: null,
            windowHeight: 0
        }
    },
    computed: {
        ...mapGetters({
            events: 'events/events'
        })
    },
    methods: {
        editEvent(index) {
            this.indexEdit = index
            this.dialog = true
        },
        addEvent(data) {
            this.events.push(data)
        },
        removeEvent(index) {
            // this.events.splice(index, 1)
        },
        handleResize() {
            this.windowHeight = window.innerHeight
        }
    },
    created() {
        let botId = this.$route.params['pathMatch']
        this.$store.dispatch('events/eventAll', botId)
        this.$store.dispatch('messages/messageAll', botId)
        this.$store.dispatch('keyboards/loadKeyboards', botId)
        this.$store.dispatch('mailingGroups/loadMailingGroups', this.$route.params['pathMatch'])
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active ;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }
</style>
